import { readOnly } from '@ember/object/computed';

import { attr } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/mlp-module';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  url: validator('presence', {
    presence: true,
    disabled: readOnly('model.useZatap'),
  }),
});

export const settings = {
  copyableOptions: { ignoreAttributes: ['contentItem'] },
};

export default class MlpAddToWalletModel extends Model.extend(Validations) {
  @attr('string') url;
  @attr('boolean', { defaultValue: false }) useZatap;
}
